'use client';

import { Popover } from '@base-ui/react/popover';
import { css, cx } from '@repo/pandacss/styled-system/css';
import { resolveColorValue } from '@repo/pandacss/tokens/colors';
import { type CSSProperties, useMemo } from 'react';
import { MdHelpOutline } from 'react-icons/md';
import { DisclosureTooltip } from '../../DisclosureTooltip';

export type RatingTooltipProps = {
  starRatingTooltip: string;
  starRatingTooltipClassName?: string;
  tooltipSize?: string;
  tooltipColor?: string;
  tooltipClassName?: string;
  triggerClassName?: string;
};

const tooltipContentClassName = css({
  textStyle: 'textSmall',
});

export function RatingTooltip({
  starRatingTooltip,
  starRatingTooltipClassName = tooltipContentClassName,
  tooltipSize = '16px',
  tooltipColor = 'neutral.dark',
  tooltipClassName,
  triggerClassName,
}: RatingTooltipProps) {
  const handler = useMemo(() => Popover.createHandle<unknown>(), []);

  const resolvedColor = useMemo(() => resolveColorValue(tooltipColor), [tooltipColor]);

  return (
    <>
      <Popover.Trigger
        handle={handler}
        className={cx(
          css({
            borderTopStyle: 'none',
            borderRightStyle: 'none',
            borderBottomStyle: 'none',
            borderLeftStyle: 'none',
            backgroundColor: 'transparent',
            color: 'var(--tooltip-color)',
            cursor: 'pointer',
            display: 'inline-flex',
            paddingTop: '0',
            paddingRight: '0',
            paddingBottom: '0',
            paddingLeft: '0',
            textStyle: 'textSmall',
          }),
          triggerClassName,
        )}
        style={
          {
            '--tooltip-color': resolvedColor,
          } as CSSProperties
        }
        aria-label="NerdWallet rating info"
      >
        <MdHelpOutline style={{ fontSize: tooltipSize }} />
      </Popover.Trigger>
      <DisclosureTooltip handler={handler} placement="bottom" tooltipClassName={tooltipClassName}>
        <span className={starRatingTooltipClassName}>{starRatingTooltip}</span>
      </DisclosureTooltip>
    </>
  );
}
